import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const HgncLink = ({ geneSymbol }) => {
  return (
    <a
      href={getVarsoUrl(
        `https://www.genenames.org/tools/search/#!/?query=${geneSymbol}`
      )}
      target="_blank"
      className="varsome-gene-link"
    >
      HGNC
    </a>
  );
};

HgncLink.propTypes = {
  geneSymbol: PropTypes.string,
};

HgncLink.defaultProps = {
  geneSymbol: null,
};

export default HgncLink;
